export default __webpack_public_path__ + "static/media/안주9.f9df234d.png";